// extracted by mini-css-extract-plugin
export default {"block":"BlockPicker__block___3P1cf","active":"BlockPicker__active___1Ivv7"};